import { http } from '../../config/axios'

export interface ServicoSimulado {
  identificador: string
  descricaoServico: string
  quantidadeTrimestral: number
  quantidadeMensal: number
  quantidade12Meses: number
  valorUnitContratado: number
  valorUnitAtual: number
  valorUnitSimulado: number
  custoMensal: number
  custoTrimestral: number
  editado: boolean
}

export interface PlanoSimulado {
  nivel: string
  idPlano: string
  descricao: string
  vcm: number
  servicos: ServicoSimulado[]
  projecaoMensal: number
  projecaoTrimestral: number
  diferencaMensalVsConsumoAtual: number
  percentualVsConsumoAtual: number
  economiaDescontosTrimestral: number
}

export interface PlanoOpcao {
  idPlano: string
  descricao: string
  vcm: number
}

export interface ConsumoProduto {
  identificador: string
  descricaoProduto: string
  quantidade12Meses: number
  valor12Meses: number
}

export interface SimulacaoResponse {
  idCliente: string
  clienteNome: string
  clienteDocumento: string
  clienteEmail?: string
  clienteResponsavel?: string
  vcmAtual?: number
  consumoMensalAtual?: number
  reajustePercentual?: number
  mesesContrato?: number
  saude?: any
  planoAbaixo?: PlanoSimulado
  planoAtual?: PlanoSimulado
  planoAcima?: PlanoSimulado
  opcoesAbaixo?: PlanoOpcao[]
  opcoesAcima?: PlanoOpcao[]
  podiumConsumo?: ConsumoProduto[]
  aviso?: string
}

export interface ServicoOverride {
  nivel: string
  identificador: string
  valorUnitSimulado: number
}

export interface SimulacaoRequest {
  reajustePercentual?: number
  mesesContrato?: number
  overrides: ServicoOverride[]
  idPlanoAbaixo?: string
  idPlanoAcima?: string
}

export interface RenovacaoEscolha {
  simulacao: SimulacaoRequest
  nivelEscolhido: string
  dataInicioVigencia?: string | Date | null
  duracaoMeses?: number
  destinatario?: string
}

export const getSimulacaoRenovacao = (idCliente: string): Promise<SimulacaoResponse> =>
  http.get(`api/renovacao/cliente/${idCliente}`).then((r) => r.data as SimulacaoResponse)

export const postSimularRenovacao = (idCliente: string, req: SimulacaoRequest): Promise<SimulacaoResponse> =>
  http.post(`api/renovacao/cliente/${idCliente}/simular`, req).then((r) => r.data as SimulacaoResponse)

export const postSalvarRenovacao = (idCliente: string, escolha: RenovacaoEscolha): Promise<SimulacaoResponse> =>
  http.post(`api/renovacao/cliente/${idCliente}/salvar`, escolha).then((r) => r.data as SimulacaoResponse)

export const postPropostaRenovacao = (idCliente: string, escolha: RenovacaoEscolha): Promise<Blob> =>
  http.post(`api/renovacao/cliente/${idCliente}/proposta`, escolha, { responseType: 'blob' }).then((r) => r.data as Blob)

export const getContratosAVencer = (dias: number): Promise<any[]> =>
  http.get(`api/client/contratos-a-vencer/${dias}`).then((r) => r.data as any[])
